
import { Component, Vue, Prop } from 'vue-property-decorator'
import FetchWrapper from '@/classes/fetchWrapper'

const CreateLearningVectorModalProps = Vue.extend({
  props: {
    canCancel: Boolean,
    close: Boolean,
    assessmentCategories: Array,
    allKeywords: Array,
    selectedUserId: Number
  }
})

Vue.prototype.$multiwatch = function (props, watcher) {
  var iterator = function (prop) {
    this.$watch(prop, watcher)
  }
  props.forEach(iterator, this)
}

@Component
export default class CreateLearningVectorModal extends CreateLearningVectorModalProps {
  data () {
    return {
      isLoading: false,
      keyword: '',
      description: '',
      subject: '',
      intention: '',
      level: '',
      category: '',
      isFormValid: false,
      isRepeatedKeyword: false
    }
  }

  get isComponentModalActive () {
    return this.close
  }

  created () {
    this.$multiwatch(['keyword', 'description', 'category', 'subject', 'intention', 'level'], function () {
      this.validateForm()
    })
  }

  validateForm () {
    this.isRepeatedKeyword = this.allKeywords.indexOf(this.keyword) > -1
    this.isFormValid = this.$refs.form.checkValidity() && this.category !== '' && !this.isRepeatedKeyword
  }

  async createLearningVector () {
    try {
      this.isLoading = true

      var data = {
        keyword: this.keyword,
        description: this.description,
        subject: this.subject,
        intention: this.intention,
        level: this.level,
        category: this.category
      }

      const resp = await FetchWrapper.post(`${process.env.VUE_APP_SERVERURL}/createLearningVector/${this.selectedUserId}`, data)

      this.isLoading = false
      if (resp.error) {
        this.$buefy.dialog.confirm({
          title: 'Error',
          message: resp.error,
          canCancel: false
        })
      } else {
        this.$buefy.dialog.confirm({
          title: 'Success',
          message: 'Learning Vector created Successfully',
          onConfirm: () => {
            this.$emit('created')
            this.$emit('close')
            this.keyword = null
            this.description = null
            this.subject = null
            this.intention = null
            this.level = null
            this.category = null
          },
          canCancel: false
        })
      }
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Something went wrong. ${e}`,
        canCancel: false
      })
    }
  }
}
